query GetUserEmailSignatureById($userId: ID!) {
    user(id: $userId) {
        id
        emailSignature
    }
}
